"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSportResponseDto = instanceOfSportResponseDto;
exports.SportResponseDtoFromJSON = SportResponseDtoFromJSON;
exports.SportResponseDtoFromJSONTyped = SportResponseDtoFromJSONTyped;
exports.SportResponseDtoToJSON = SportResponseDtoToJSON;
exports.SportResponseDtoToJSONTyped = SportResponseDtoToJSONTyped;
/**
 * Check if a given object implements the SportResponseDto interface.
 */
function instanceOfSportResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('minTier' in value) || value['minTier'] === undefined)
        return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined)
        return false;
    return true;
}
function SportResponseDtoFromJSON(json) {
    return SportResponseDtoFromJSONTyped(json, false);
}
function SportResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'minTier': json['minTier'],
        'displayOrder': json['displayOrder'],
        'language': json['language'] == null ? undefined : json['language'],
        'isFallback': json['isFallback'] == null ? undefined : json['isFallback'],
    };
}
function SportResponseDtoToJSON(json) {
    return SportResponseDtoToJSONTyped(json, false);
}
function SportResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'minTier': value['minTier'],
        'displayOrder': value['displayOrder'],
        'language': value['language'],
        'isFallback': value['isFallback'],
    };
}
